import { apiClient } from 'common/clients/api.client';
import { API_ENDPOINTS } from 'common/constants/api-endpoints.constants';
import { EApiPathParams } from 'common/enums/api-path-params.enum';
import {
  TCounterpartyAvailableBranchesResData,
  TCounterpartyBranchesResData,
  TCounterpartyCreateBranchReqData,
  TCounterpartyCreateBranchResData,
  TCounterpartyBranchesReqParams,
  TPermissionTableByBranchReqParams,
  TPermissionTableByBranchResData,
  TAddBranchRolePermissionResData,
  TAddBranchRolePermissionReqData,
  TDeleteBranchRolePermissionReqData,
  TDeleteBranchRolePermissionResData,
  TDeleteRoleInBranchRoleReqData,
  TDeleteRoleInBranchRoleResData,
  TCreateRoleInBranchRoleReqData,
  TCreateRoleInBranchRoleResData,
} from '../types/branch.types';

export const counterpartyGetBranchesService = async (
  counterpartyGUID: string,
  params?: TCounterpartyBranchesReqParams
): Promise<TCounterpartyBranchesResData> => {
  const url = API_ENDPOINTS.BRANCHES.COUNTERPARTY_BRANCHES.replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const config = {
    params,
  };
  const res = await apiClient.get<TCounterpartyBranchesResData>(url, config);

  return res.data;
};

export const counterpartyCreateBranchService = async (
  counterpartyGUID: string,
  reqData: TCounterpartyCreateBranchReqData,
): Promise<TCounterpartyCreateBranchResData> => {
  const url = API_ENDPOINTS.BRANCHES.COUNTERPARTY_BRANCHES.replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const res = await apiClient.post<TCounterpartyCreateBranchResData>(url, reqData,);

  return res.data;
};

export const counterpartyGetAvailableBranchesService = async (
  counterpartyGUID: string,
  params?: TCounterpartyBranchesReqParams
): Promise<TCounterpartyAvailableBranchesResData> => {
  const url = API_ENDPOINTS.BRANCHES_ACCESS.COUNTERPARTY_BRANCHES_ACCESS_LIST
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const config = {
    params,
  };
  const res = await apiClient.get<TCounterpartyAvailableBranchesResData>(url, config);

  return res.data;
};

export const getPermissionTableByBranchService = async (
  counterpartyGUID: string,
  branchGUID: string,
  params?: TPermissionTableByBranchReqParams
): Promise<TPermissionTableByBranchResData> => {
  const url = API_ENDPOINTS.BRANCHES_ACCESS.COUNTERPARTY_BRANCH_PERMISSION_TABLE
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGUID)
    .replace(EApiPathParams.BranchGuid, branchGUID);
  const config = {
    params,
  };
  const res = await apiClient.get<TPermissionTableByBranchResData>(url, config);

  return res.data;
};

export const addPermissionToBranchRoleService = async (
  counterpartyGUID: string,
  reqData: TAddBranchRolePermissionReqData,
): Promise<TAddBranchRolePermissionResData> => {
  const url = API_ENDPOINTS.BRANCHES_ACCESS.COUNTERPARTY_BRANCHES_ACCESS_PERMISSION
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const res = await apiClient.post<TAddBranchRolePermissionResData>(url, reqData);
  return res.data;
};

export const removePermissionToBranchRoleService = async (
  counterpartyGUID: string,
  reqData: TDeleteBranchRolePermissionReqData,
): Promise<TDeleteBranchRolePermissionResData> => {
  const url = API_ENDPOINTS.BRANCHES_ACCESS.COUNTERPARTY_BRANCHES_ACCESS_PERMISSION
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const res = await apiClient.delete<TDeleteBranchRolePermissionResData>(url, {
    data: reqData,
  });
  return res.data;
};

export const deleteRoleInBranchRoleService = async (
  counterpartyGUID: string,
  reqData: TDeleteRoleInBranchRoleReqData,
): Promise<TDeleteRoleInBranchRoleResData> => {
  const url = API_ENDPOINTS.BRANCHES_ACCESS.COUNTERPARTY_BRANCHES_ACCESS_ROLE
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGUID);
  const res = await apiClient.delete<TDeleteRoleInBranchRoleResData>(url, {
    data: reqData,
  });
  return res.data;
};

export const createRoleInBranchRoleService = async (
  counterpartyGuid: string,
  reqData: TCreateRoleInBranchRoleReqData
): Promise<TCreateRoleInBranchRoleResData> => {
  const url = API_ENDPOINTS.BRANCHES_ACCESS.COUNTERPARTY_BRANCHES_ACCESS_ROLE
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGuid);
  const res = await apiClient.post<TCreateRoleInBranchRoleResData>(url, reqData);

  return res.data;
};
